export const US_STATES = ['NM', 'OK', 'TX'];
